import { StatusUserEnum } from "definitions/Others";
import { Ticket } from "definitions/Ticket";
import { User, UserTypes } from "definitions/User";
import React from "react";
import { i18n } from "translate/i18n";

function isActionAllowed(
  user: User,
  ticket: Ticket,
  blockTicket: boolean,
  companyStatus: StatusUserEnum
): boolean {
  if (blockTicket && companyStatus !== StatusUserEnum["Em aberto"])
    return false;

  // is ticket closed?
  if (ticket.CompanyStatus.statusUser === StatusUserEnum.Concluido)
    return false;

  // if ticket has no agent, anyone except agents can redirect ticket to another agent
  if (!ticket.User) {
    return (
      user.UserTypeId === UserTypes["Atendente"] ||
      user.UserTypeId === UserTypes["Atendente IH"] ||
      user.UserTypeId === UserTypes["Atendente(14)"] ||
      user.UserTypeId === UserTypes["Atendente IH(15)"]
    );
  }

  // if ticket is under bot control...
  if (ticket.User.UserTypeId === UserTypes.BOT) {
    // only managers can redirect
    return (
      user.UserTypeId === UserTypes["Gerente IH"] ||
      user.UserTypeId === UserTypes["Gerente"]
    );
  }

  return true;
}

type RedirectTicketProps = {
  selecteduser: string;
  blockTicket: boolean;
  user: User;
  ticket: Ticket;
  companyStatus: number; // seria StatusUser ?
  handleOptionChange: (value: number | string) => any;
  confirmAction: () => any;
  listUser: Partial<User>[];
};
export function RedirectTicketForm(props: RedirectTicketProps): JSX.Element {
  const {
    selecteduser,
    blockTicket,
    user,
    ticket,
    handleOptionChange,
    companyStatus,
    listUser,
    confirmAction,
  } = props;

  if (!user.allowForwardTicket) return <></>;

  return (
    <>
      <label className="title-combo-details-client-chat">
        {i18n.t("redirectCall") as string}
      </label>
      <div className="form-row">
        <div className="form-group col-lg-8">
          <select
            className="form-control"
            id="example-select"
            value={selecteduser}
            disabled={
              !isActionAllowed(user, ticket, blockTicket, companyStatus)
            }
            onChange={(value) => handleOptionChange(value.target.value)}
          >
            {listUser.length > 0 ? (
              <>
                <option>{i18n.t("select") as string}</option>
                {listUser.map((data, index) => (
                  <option key={index} value={data.id}>
                    {data.nickName}
                  </option>
                ))}
              </>
            ) : (
              <option>{i18n.t("noAgentOnline") as string}</option>
            )}
          </select>
        </div>
        <button
          type="button"
          className="btn btn-outline-success"
          style={{ height: 38 }}
          onClick={confirmAction}
          disabled={!isActionAllowed(user, ticket, blockTicket, companyStatus)}
        >
          <i className=" uil-exchange"></i> {i18n.t("confirm") as string}
        </button>
      </div>
    </>
  );
}
